import { render, staticRenderFns } from "./CadasterChangedBuilding.vue?vue&type=template&id=06903c9a&scoped=true&"
import script from "./CadasterChangedBuilding.vue?vue&type=script&lang=js&"
export * from "./CadasterChangedBuilding.vue?vue&type=script&lang=js&"
import style0 from "./CadasterChangedBuilding.vue?vue&type=style&index=0&id=06903c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06903c9a",
  null
  
)

export default component.exports